import Collapse from '@mui/material/Collapse';
import { styled } from "@mui/system";

// メールボックス
export const MailBoxCollapse = styled(Collapse)(({ theme }) => ({
    border: '1px solid #ccc',
    boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px', 
    padding: '16px', 
    backgroundColor: '#fff', 
}));
